const guiColors = {
    'motion-primary': '#ff4c4c',
    'motion-primary-transparent': '#ff4c4ce6',
    'motion-tertiary': '#cc3333',

    'looks-secondary': '#ff4c4c',
    'looks-secondary-light': '#fe9c9c',
    'looks-secondary-lighter': '#ffd7d7',
    'looks-transparent': '#ff4d4d59',
    'looks-light-transparent': '#ff4d4d26',
    'looks-secondary-dark': 'hsla(0, 42%, 51%, 1)',
    'looks-secondary-darker': 'hsl(0,30%,28%)',
    'looks-secondary-deep-dark': 'hsl(0,15%,11%)',

    'extensions-primary': 'hsla(10, 85%, 65%, 1)',
    'extensions-tertiary': 'hsla(10, 85%, 40%, 1)',
    'extensions-transparent': 'hsla(10, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#ff8c8c',

    // eslint-disable-next-line max-len
    'menu-bar-background-image': 'linear-gradient(to right, red,orange,yellow,green,blue,indigo,violet)',
    'menu-bar-background-image-dark': 'linear-gradient(to right, #8C0000,#991D00,#969600,#008C00,#002BA6,#4400A6,#8A00A6)'
};

const blockColors = {
    checkboxActiveBackground: '#ff4c4c',
    checkboxActiveBorder: '#cc3333'
};

export {
    guiColors,
    blockColors
};
